<template>
  <div id="emailContainer">
    <i id="open" class="el-icon-caret-left" v-on:click="moveEmailContainer" ></i>

    <el-button v-on:click="sendEmail" :disabled="to === '' || subject === '' || body === ''" icon="el-icon-edit" plain>Send</el-button>

    <div id="inputs">
      <el-input placeholder="To... (ex. test@dave.com, test2@dave.com)" v-model="to">
        <template slot="prepend">To: </template>
      </el-input>
      <el-input placeholder="Cc..." v-model="cc">
        <template slot="prepend">Cc: </template>
      </el-input>
      <el-input placeholder="Bcc..." v-model="bcc">
        <template slot="prepend">Bcc: </template>
      </el-input>
      <el-input placeholder="Subject..." v-model="subject">
        <template slot="prepend">Subject: </template>
      </el-input>

      <el-input
        type="textarea"
        :rows="10"
        placeholder="Input your message"
        v-model="body">
      </el-input>

      <el-button id="addInfo" v-on:click="addInfo" icon="el-icon-plus" plain>Add info</el-button>
    </div>
  </div>
</template>

<script>

  export default {
    name: 'Email',
    props: ["name", "resistorWear", "fluidLevel"],
    data () {
      return {
        to: '',
        cc: '',
        bcc: '',
        subject: '',
        body: ''
      }
    },
    methods: {
      moveEmailContainer(){
        document.getElementById("emailContainer").classList.toggle("active");
        document.getElementById("open").classList.toggle("active");
      },
      sendEmail(){
        this.to = '';
        this.cc = '';
        this.bcc = '';
        this.subject = '';
        this.body = ''
      },
      addInfo(){
        this.body += `Oven name: ${this.name}
Resistor wear: ${this.resistorWear}%
Fluid level: ${this.fluidLevel}%`
      }
    }
  }
</script>

<style scoped>
  #emailContainer{
    position: fixed;
    display: flex;
    flex-flow: row wrap;
    width: 40%;
    top: 130px;
    right: 0;
    background-color: #ffffff;
    transform: translateX(100%);
    height: 80vh;
    border-left: 2px solid #e4e7ed;
    border-top: 2px solid #e4e7ed;
    border-bottom: 2px solid #e4e7ed;
    border-radius: 10px;
    padding: 1%;
    transition: transform 0.5s ease-in;
  }
  #addInfo{
    width: 150px;
    height: 50px;
  }
  .el-button{
    position: relative;
    margin-right: 2%;
    float: left;
    height: 25%;
  }
  .el-input{
    text-align: left!important;
  }
  #emailContainer.active{
    transform: translateX(0%);
  }
  #inputs{
    flex: 1;
    display: flex;
    flex-direction: column;
    height: auto;
  }
  #inputs .el-input, .el-textarea{
    padding-bottom: 1%;
  }
  #open{
    position: absolute;
    cursor: pointer;
    left: -15px;
    top: 50%;
    transition: .50s transform ease-out;
    transform: scale(1.50);
  }
  #open:hover{
    transform: scale(2);
  }
  #open.active{
    transform: rotate(180deg);
  }
</style>



// WEBPACK FOOTER //
// src/components/Email.vue